module.exports = __webpack_public_path__ + "img/img12.712ae914.svg";